import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { colors } from '@guryou/colors';
import { ServiceTypes } from '@guryou/core';
import { FlexRow, FullScreenSpinner, Modal, openModal } from '@guryou/html-components';
import { stateIsLoading } from '@guryou/redux';
import { getReservationInitialDate } from '@guryou/utils';
import AccordionDetailsCourse from './AccordionDetailsCourse';
import AccordionDetailsService from './AccordionDetailsService';
import Popup from './Popup';
import { WidgetContext } from './WidgetContext';

const WidgetServices = ({ courseView, eventView }) => {
  const { t } = useTranslation();
  const dateTimeFrom = null;

  const dispatch = useDispatch();
  const { personnelTimeSlots, personnelDateSlots } = useSelector(state => state.widget);
  const { activeServiceId, setActiveServiceId, services, courses, sessionActiveStep, fontF, fontS, paymentOptions } = useContext(WidgetContext);

  const [selectedService, setSelectedService] = useState(0);
  const [selectedSubservice, setSelectedSubservice] = useState(null);
  const [localData, setLocalData] = useState({
    resourceId: null,
    date: getReservationInitialDate(dateTimeFrom, personnelDateSlots),
    time: null,
  });

  const serviceOnline = eventView || courseView ? paymentOptions.data.courseOnline : paymentOptions.data.serviceOnline;
  const serviceOnSite = eventView || courseView ? paymentOptions.data.courseOnsite : paymentOptions.data.serviceOnsite;
  const serviceMembership = eventView || courseView ? paymentOptions.data.courseMembership : paymentOptions.data.serviceMembership;

  const listItems = courseView
    ? courses.data.filter(c => c.serviceType === ServiceTypes.course)
    : eventView
    ? courses.data.filter(c => c.serviceType === ServiceTypes.event)
    : services.data;

  const pressedDetails = subservice => {
    dispatch(openModal('subservicePopUp'));
    setSelectedSubservice(subservice);
  };

  const openOrCloseModal = ({ isExpanded, subservice }) => {
    setActiveServiceId(isExpanded ? subservice.id : null);
  };

  return (
    <FlexRow>
      {stateIsLoading([personnelTimeSlots, personnelDateSlots]) && <FullScreenSpinner />}
      <Modal id="subservicePopUp" maxWidth="lg">
        <Popup subservice={selectedSubservice} optionSelected={localData} dispatch={dispatch} />
      </Modal>

      <div class="md:flex w-full">
        <ul class="flex-column space-y space-y-4 text-sm font-medium text-gray-500 dark:text-gray-400 md:me-4 mb-4 md:mb-0 min-w-[20%]">
          {listItems?.map((service, idx) => {
            console.log(service);
            return (
              <li key={service.id} onClick={() => setSelectedService(idx)}>
                <a
                  key={service.id}
                  href="#"
                  class="inline-flex items-center px-4 py-3 text-white bg-blue-700 rounded-lg active w-full dark:bg-blue-600 relative"
                  aria-current="page"
                  style={{ backgroundColor: selectedService === idx ? colors.mandy : colors.stormGray }}
                >
                  {`${service.name} (${service?.offers.length})`}
                </a>
              </li>
            );
          })}
        </ul>
        <div class="p-6 pt-0 text-medium text-gray-500 dark:text-gray-400 rounded-lg w-full">
          <h3 class="text-lg font-bold text-gray-900 mb-2 max-w-md truncate">{listItems[selectedService].name}</h3>
          <p class="mb-2">Compare our available services and plans below to determine which one best suits your needs.</p>

          <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 w-full mt-8">
            {listItems[selectedService]?.offers?.map(subservice => {
              return (
                <div class="w-full max-w-sm p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8">
                  <h5 class="mb-4 text-xl font-medium trancking-tight font-semibold">{subservice?.name}</h5>
                  <div class="flex items-baseline text-gray-900">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 shrink-0" fill="none" viewBox="0 0 16 16">
                      <circle cx="8" cy="8" r="8" fill="currentColor" class="text-gray-300" />
                      <circle cx="8" cy="8" r="3" fill="currentColor" class="text-gray-500" />
                    </svg>
                    <span class="text-3xl font-semibold ml-2">
                      <span class="ms-1 text-xl font-normal text-gray-500">{t('GENERAL.price')}: </span>
                    </span>
                    <span class="ms-1 text-xl font-normal text-gray-500 trancking-tight">
                      {subservice?.price}
                      <span class="text-xl "> €</span>
                    </span>
                  </div>
                  {!courseView && !eventView && (
                    <div class="flex items-baseline text-gray-900">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 shrink-0" fill="none" viewBox="0 0 16 16">
                        <circle cx="8" cy="8" r="8" fill="currentColor" class="text-gray-300" />
                        <circle cx="8" cy="8" r="3" fill="currentColor" class="text-gray-500" />
                      </svg>
                      <span class="text-3xl font-semibold ml-2">
                        <span class="ms-1 text-xl font-normal text-gray-500">
                          {t('GENERAL.duration')}: {subservice?.duration} {t('GENERAL.minute')}
                        </span>
                      </span>
                    </div>
                  )}

                  {eventView && (
                    <div class="flex items-baseline text-gray-900">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 shrink-0" fill="none" viewBox="0 0 16 16">
                        <circle cx="8" cy="8" r="8" fill="currentColor" class="text-gray-300" />
                        <circle cx="8" cy="8" r="3" fill="currentColor" class="text-gray-500" />
                      </svg>
                      <span class="text-3xl font-semibold ml-2">
                        <span class="ms-1 text-xl font-normal text-gray-500">
                          {t('GENERAL.duration')}: {subservice?.sessions.length} {t('GENERAL.session')}
                        </span>
                      </span>
                    </div>
                  )}

                  {courseView && (
                    <div class="flex items-baseline text-gray-900">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 shrink-0" fill="none" viewBox="0 0 16 16">
                        <circle cx="8" cy="8" r="8" fill="currentColor" class="text-gray-300" />
                        <circle cx="8" cy="8" r="3" fill="currentColor" class="text-gray-500" />
                      </svg>
                      <span class="text-3xl font-semibold ml-2">
                        <span class="ms-1 text-xl font-normal text-gray-500">
                          {t('BOOK_WIDGET.pricingModel')}: {subservice?.model}
                        </span>
                      </span>
                    </div>
                  )}
                  <ul role="list" class="space-y-5 my-7"></ul>
                  {(serviceOnline || serviceOnSite || serviceMembership) && (
                    <button
                      onClick={e => {
                        openOrCloseModal({
                          e,
                          isExpanded: true,
                          subservice,
                        });
                      }}
                      type="button"
                      style={{ backgroundColor: colors.mandy }}
                      class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-200 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-red-100 font-medium rounded-lg text-sm px-5 py-2.5 inline-flex justify-center w-full text-center"
                    >
                      {t('GENERAL.payNow')}
                    </button>
                  )}
                  {!courseView && !eventView && activeServiceId === subservice.id ? (
                    <AccordionDetailsService
                      subservice={subservice}
                      dispatch={dispatch}
                      localData={localData}
                      setLocalData={setLocalData}
                      personnelTimeSlots={personnelTimeSlots}
                      personnelDateSlots={personnelDateSlots}
                      closeModal={() => openOrCloseModal({ isExpanded: false, subservice })}
                    />
                  ) : (
                    (courseView || eventView) &&
                    activeServiceId === subservice.id && (
                      <AccordionDetailsCourse
                        subservice={subservice}
                        sessionActiveStep={sessionActiveStep}
                        closeModal={() => openOrCloseModal({ isExpanded: false, subservice })}
                      />
                    )
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </FlexRow>
  );
};

export default WidgetServices;
